import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Row, Col } from 'react-bootstrap'
import TeamMetricsSortPage from './TeamMetricSort';

export default class MultiTeamMetricsSortPage extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        let instanceID = localStorage.getItem("instanceId");
        let event = localStorage.getItem("event");

        if (instanceID === null || event === null) {
            window.location = '/'
        }
    }

    render() {
        return(
            <Container fluid>
                <Row>
                    <Col><TeamMetricsSortPage title={false}/></Col>
                    <Col><TeamMetricsSortPage title={false}/></Col>
                    <Col><TeamMetricsSortPage title={false}/></Col>
                </Row>
            </Container>
        )
    }

}